import React from "react";
import { ModalConfirm } from "@talentbait/shared-components";

const ArchivePictureModal = ({ confirmedAction, cancelledAction }) => {
  return (
    <ModalConfirm
      showDescription={true}
      labelConfirm={"Ja, Löschen"}
      description={
        "Bitte beachten Sie: das Bild kann nicht wiederhergestellt werden. Sind Sie sicher, dass Sie das Bild dauerhaft entfernen möchten?"
      }
      cancelledAction={cancelledAction}
      confirmedAction={confirmedAction}
    />
  );
};

export default ArchivePictureModal;
